import { Button } from '@/components/ui/button'
import { useNavigation } from '@/hooks/use-navigation'
import { AlertCircle, ArrowLeft, Home } from 'lucide-react'

/**
 * 404 Not Found page with smart navigation
 */
export default function NotFound() {
  const { navigateWithGuards, getDefaultRedirect, navigationState } = useNavigation()

  const handleGoBack = () => {
    window.history.back()
  }

  const handleGoHome = () => {
    const defaultRoute = getDefaultRedirect()
    navigateWithGuards(defaultRoute)
  }

  return (
    <div className="min-h-screen bg-linen flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-20 h-20 bg-lilac-900 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertCircle className="w-10 h-10 text-info" />
        </div>
        
        <h1 className="font-display text-6xl font-bold text-night-900 mb-4">404</h1>
        <h2 className="font-display text-2xl font-bold text-night-900 mb-2">
          Page Not Found
        </h2>
        <p className="font-body text-night-500 mb-8">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        
        <div className="space-y-3">
          <Button 
            onClick={handleGoHome}
            className="w-full inline-flex items-center justify-center gap-2"
          >
            <Home className="w-4 h-4" />
            {navigationState.isAuthenticated ? 'Go to Dashboard' : 'Go to Homepage'}
          </Button>
          
          <Button 
            onClick={handleGoBack}
            variant="outline" 
            className="w-full inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}